import request from '../utils/request.js'

// 问诊评价列表
export function getEvaluateList(data) {
    return request({
        url: '/user-service/askEvaluate/page',
        method: 'post',
        data,
        headers: {
            "content-type": "application/json",
        },
    })
}

// 获取问诊评价
export function getEvaluateInfo(params) {
    return request({
        url: `/user-service/askEvaluate/getByAskNo/${params.askNo}`,
        method: 'get',
        params,
        headers: {
            "content-type": "application/json",
        },
    })
}

// 更新评价
export function updateEvaluate(data) {
    return request({
        url: '/user-service/askEvaluate/update',
        method: 'post',
        data,
        headers: {
            "content-type": "application/json",
        },
    })
}